import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ListActualCosts from './ListActualCosts';

//Create Actual Costs dependencies
import MyTooltip from '../common/MyTooltip';
import CreateActualCostModel from './CreateActualCostModel';

import {
  CREATE_PROJECT_MODEL_ACTION_CREATE, 
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
  ROLE_VIEWER,
  STATUS_PROJECT_PUBLISHED
} from '../common/redux/constantes';


export class ActualCost extends Component {

  state = {
    openCreateActualCostDialog:false,
    createActualCostDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
    actualCostEdit:{}
  }


  static propTypes = 
  {
    actual: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };


  closeCreateActualCostDialog = ()=>
  {
    this.setState({openCreateActualCostDialog:false});
    this.list.wrappedInstance.refreshTable();
  }

  openCreateActualCostDialog = ()=>{
    this.setState({
      openCreateActualCostDialog:true, 
      createActualCostDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
      actualCostEdit:{}
    });
  }



  editActualCost = (actual_cost)=>{
     this.setState({
      openCreateActualCostDialog:true, 
      createActualCostDialogAction:CREATE_PROJECT_MODEL_ACTION_EDIT,
      actualCostEdit:actual_cost
    });
  }

  showActualCost = (actual_cost)=>{
     this.setState({
      openCreateActualCostDialog:true, 
      createActualCostDialogAction:CREATE_PROJECT_MODEL_ACTION_SHOW,
      actualCostEdit:actual_cost
    });
  }


  render() {
    return (
      <div >
            <ListActualCosts 
              ref={instance => { this.list = instance; }} 
              project={this.props.project} 
              editActualCost={this.editActualCost} 
              showActualCost={this.showActualCost}
              project_status={this.props.project_status}/>
            <CreateActualCostModel 
              openDialog={this.state.openCreateActualCostDialog} 
              closeDialog={this.closeCreateActualCostDialog} 
              actionDialog={this.state.createActualCostDialogAction}
              actualCostEdit={this.state.actualCostEdit}
              project={this.props.project}
            />
            {
              Number(localStorage.getItem("role")) !== ROLE_VIEWER && this.props.project_status===STATUS_PROJECT_PUBLISHED?
              (<MyTooltip openDialog={this.openCreateActualCostDialog} />)
              :null
            }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    actual: state.actual,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActualCost);



// WEBPACK FOOTER //
// ./src/features/actual/Actual.js